import { render } from "./TopNewsList.vue?vue&type=template&id=35053530&scoped=true"
import script from "./TopNewsList.vue?vue&type=script&lang=js"
export * from "./TopNewsList.vue?vue&type=script&lang=js"

import "./TopNewsList.vue?vue&type=style&index=0&id=35053530&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-35053530"

export default script